// extracted by mini-css-extract-plugin
module.exports = {"column":"column--1sq71","name":"name--2Mgg9"};